/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Home_Hero_BadgeInputs */

const en_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome to the ${i?.companyName} Customer Portal`)
};

const fr_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bienvenue sur le portail ${i?.companyName}`)
};

/**
* | output |
* | --- |
* | "Welcome to the {companyName} Customer Portal" |
*
* @param {Home_Hero_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_badge = /** @type {((inputs: Home_Hero_BadgeInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_BadgeInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_badge(inputs)
	return fr_home_hero_badge(inputs)
});